import React, { useEffect, useState } from "react";
import { QqDispatchType } from "../../message-interop/qq-dispatch.type";
import { MessageProcessorFactory } from "../../message-interop/message-processor/message-processor.factory";
import { QqGroupTypeEnum } from "../../model/qq-group-type.enum";
import { QqControlsGroupOpenControlRaw } from "../../controls/qq-controls-group-open-control.raw";
import { QqControlsGroupAdditionalControlRaw } from "../../controls/qq-controls-group-additional-control.raw";
import { QqStateType } from "../../message-interop/qq-state.type";
import { QqQuizRawContainerComponent } from "../container/qq-quiz-raw.container.component";
import { QqSelectedResultsRawContainerComponent } from "../container/qq-selected-results-raw.container.component";
import { QqPageComponentProps } from "./qq-page.props";
import { QqBundleService } from "../../services/qq-bundle.service";

export const QqPageRawComponent: React.FunctionComponent<QqPageComponentProps> =
  ({ questions }) => {
    const [json, setJson] = useState<string>(
      JSON.stringify(questions, null, 2)
    );

    const [qqState, setQqState] = useState<QqStateType>({
      ctrlPos: {},
      ctrlBundle: {},
      qqBundle: questions,
      currentValues: {},
      currentOptions: {},
    });

    useEffect(() => {
      const bundleService = new QqBundleService(questions);
      const { currentValues, currentOptions } =
        bundleService.fillDefault(questions);

      setQqState({
        ctrlPos: {},
        ctrlBundle: {},
        qqBundle: questions,
        currentValues: currentValues,
        currentOptions: currentOptions,
      });
    }, [questions]);

    const dispatch: QqDispatchType = (action) => {
      const processor = new MessageProcessorFactory();
      const newState = processor.process(action, qqState);

      if (newState !== qqState) setQqState(newState);
    };

    const groups = qqState.qqBundle.groups.map((group, index) =>
      group.type === QqGroupTypeEnum.open ? (
        <QqControlsGroupOpenControlRaw
          key={index}
          dispatch={dispatch}
          group={group}
          state={qqState}
        />
      ) : (
        <QqControlsGroupAdditionalControlRaw
          key={index}
          dispatch={dispatch}
          group={group}
          state={qqState}
        />
      )
    );

    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <QqQuizRawContainerComponent dispatch={dispatch} state={qqState}>
            {groups}
          </QqQuizRawContainerComponent>
          <QqSelectedResultsRawContainerComponent
            dispatch={dispatch}
            state={qqState}
            values={qqState.currentValues}
            currentOptions={qqState.currentOptions}
          />
        </div>
        <div style={{ border: "1px solid blue", padding: "4px" }}>
          <textarea
            onChange={(e) => {
              setJson(e.target.value);
            }}
            name="Text1"
            style={{
              width: "90vw",
              height: "300px",
            }}
          >
            {json}
          </textarea>
          <br />
          <button
            onClick={() => {
              try {
                const parsed = JSON.parse(json);
                setQqState({
                  ...qqState,
                  qqBundle: parsed,
                });
              } catch (e) {
                alert(e);
              }
            }}
          >
            Update
          </button>
        </div>
      </React.Fragment>
    );
  };
